export const projectItem = {
  methods: {
    returnRolesLength(item) {
      let arr = item.permissions.filter(item => item.value < 4);
      return arr.length
    },
    returnSectionsLength(item) {
      let itemsLength = 0;
      let childArr = (items) => {
        items.forEach((itemProject) => {
          if (itemProject.id === item.id) {
            itemsLength = itemProject.items.length
          }
          if (itemProject.items && itemProject.items.length > 0) {
            childArr(itemProject.items)
          }
        })
      }
      if (this.project) {
        childArr(this.project.items)
      }
      return itemsLength
    },
    returnThingsLength(item) {
      return item.devices.length
    },
  }
}
